<template>
    
  <div>
    <!--报价销售详情-->
    <el-drawer
        class="drawer"
        :append-to-body="true"
        size="500px"
        :show-close="false"
        :visible.sync="innerDrawer"
        :before-close="handleClose"
        ref="drawerRef"
        >
        <div class=" drawer-content">
            <div class="quote-history">
                <div class="team-title">
                    <div>
                        <div class="team-title-tiem">{{ sales.offer_name }}</div>
                        <div class="team-title-name">历史报价</div>
                    </div>
                    <div class="dayDate-top-close" @click="$emit('close')">
                        返回
                    </div>
                </div>
                <!-- <div class="quote-history-btn" v-if="c_hotel_id&&c_hotel_id!=0">
                    <el-button type="primary" @click="openCtripDetail"  style="width: 100%;"><i class="iconfont icon-xiecheng"></i>查看OTA价格</el-button>
                </div> -->
                <div class="quote-history-btn" >
                    <el-button  @click="$emit('openCtripDetail',{data:{offer_store_id:sales.offer_store_id,offer_uid:sales.offer_uid},hotel_title:sales.offer_name,id:2})"  style="width: 100%;"><i class="iconfont icon-quxiantu"></i>查看图表数据</el-button>
                </div>
                <div v-for="(item,index) in list" :key="index" class="quote-item">
                    <div class="quote-item-date">{{item.date| formatTimestamp(2)}}</div>
                    <div v-for="series in item.series" :key="series.oid" class="quote-item-series">
                        <div class="series" @click="goForDetail(series,item.date)">订单号：{{series.oid}} <p><i class="el-icon-arrow-right"></i></p></div>
                        <div v-for="(offer,index) in series.offer_info" :key="index" class="offer_info" >
                            <div >{{offer.offer_title}}</div>
                            <div class="money" ><span>¥</span>{{offer.offer_price}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
     </el-drawer>
  </div>
</template>

<script>
  import {mapState, mapGetters, mapActions} from 'vuex'
export default {
  name: '',
  components: {},
  props: {
    innerDrawer:{
      type:Boolean,
      default:false
    },
    sales:{
      type:Object,
      default:()=>{}
    },
  },
  data() {
    return {
        formData:{
            page:2,
            num:12,
            offer_store_id:'',
            offer_uid:'',
        },
        list:[],
        hasMore: true,   // 是否还有更多数据
        loading: true,   // 加载中状态（防抖）
        c_hotel_id: '',                   //携程酒店id
    };
  },
  computed: {},
  watch: {
    sales:{
      handler(newVal,oldVal){
        console.log(newVal);
        if(newVal.offer_store_id){
            this.list=[];
            this.formData.page=1;
            this.hasMore = true;   // 是否还有更多数据
            this.loading = true;   // 加载中状态（防抖）
            this.formData.offer_store_id=newVal.offer_store_id;
            this.formData.offer_uid=newVal.offer_uid;
            this.loadList();
            // this.viewPrice();
        }
      },
      deep:true,
      immediate:true
    },
    innerDrawer(val){
        if(val){
            // 抽屉打开，DOM渲染完成后绑定滚动
            this.$nextTick(() => {
            const bodyDom = this.$refs.drawerRef.$el.querySelector('.el-drawer__body')
            if (bodyDom) {
                bodyDom.addEventListener('scroll', this.handleDrawerScroll)
            }
            })
        }else{
            // 抽屉关闭，移除滚动事件
            this.$nextTick(() => {
            const bodyDom = this.$refs.drawerRef.$el.querySelector('.el-drawer__body')
            if (bodyDom) {
                bodyDom.removeEventListener('scroll', this.handleDrawerScroll)
            }
            })
        }
    }
  },
  created() {},
  mounted() {},
  methods: {
    ...mapActions(['POST_HistoryOfferHotelSale','POST_HotelDetail']),
    loadList(){
        // 标记为加载中，防止重复请求
        this.loading = true
        this.POST_HistoryOfferHotelSale({
            data: {
                ...this.formData
            },
            successFun: (res) => {
                const newData = res.list; // 接口返回的新数据
                const total = res.count;  // 接口返回的总数据量（可选)
                // this.list = [...this.list, ...newData] || [];
                this.hasMore = this.formData.page * this.formData.num < total;
                this.formData.page=newData.length>0?this.formData.page+1:this.formData.page;
                this.loading = false;
                this.getServerData([ ...newData]);
                this.$nextTick(() => {
                    // 确保DOM更新完成后再绑定滚动事件
                    this.$refs.drawerRef.$el.querySelector('.el-drawer__body').addEventListener('scroll', this.handleDrawerScroll)
                })
            }
        })
    },
        // 处理滚动事件
    handleDrawerScroll(e) {
      const { scrollTop, scrollHeight, clientHeight } = e.target
      // 容错10px，解决浏览器小数滚动精度问题
      const isReachBottom = scrollTop + clientHeight >= scrollHeight - 10
      if (isReachBottom && !this.loading) {
        // 无更多数据或正在加载时，阻止重复请求
        if (!this.hasMore || this.loading) return;
            this.loadList()
      }
    },
    //查看携程价格
    viewPrice(){
        this.POST_HotelDetail({
            data:{
                store_id:this.sales.offer_store_id,
            },
            successFun:(res)=>{
                console.log(res);
                this.c_hotel_id=res.c_hotel_id;
            }
        })
    },
    //整合数据
    getServerData(list) {
        let chartData=[],formGroup=[],formData=[];
        list.forEach(item=>{
            if(item.room_offer_arr){item.room=item.room_offer_arr};
            if(item.room&&item.room.list.length>0){
                item.room.list.forEach(room=>{
                    if(room.offer_info){
                        chartData.push({oid:item.oid,...room})
                    }else{
                        chartData.push({oid:item.oid,offer_info:[room],date:item.offer_time})
                    }
                    
                })
            }
        })
        chartData.forEach(item=>{
            const findIndex = formData.findIndex(data => data.date === item.date);
            //相同的房型
            if (findIndex > -1) {
                //相同房型不同时间则增加
                formData[findIndex].series.push({oid:item.oid,offer_info:item.offer_info||{item}})
            //不同的房型
            }else{
                //默认时间戳1781107200
                formData.push({...item,series:[{oid:item.oid,offer_info:item.offer_info||{item}}]})
            }
        })
        this.list=[...this.list,...formData];
    },
    //打开携程酒店详情
    openCtripDetail(){
        if(!this.c_hotel_id){
            return;
        }
        //当前日期
        let date = new Date();
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        //日后默认5天
        let checkOut = new Date(date);
        checkOut.setDate(checkOut.getDate() + 5);
        window.open(`https://hotels.ctrip.com/hotels/detail/?hotelId=${this.c_hotel_id}&checkIn=${year}-${month}-${day}&checkOut=${year}-${month}-${checkOut.getDate()}&adult=1&children=0&crn=1`);
    },
    /*跳转查看订单详情页*/
    goForDetail(cardItem,date) {
       let offer_info=this.getOfferInfo(cardItem.offer_info,date);
        let routeUrl = this.$router.resolve({
            name: 'OrderDetail',
            query: {
                orderId: cardItem.oid,
                historyPrice:1,
                flag:'v',
                offer_info:JSON.stringify(offer_info),
                date:date,
            }
        });
        window.open(routeUrl.href, '_blank');
    },
    //拼接成报价信息
    getOfferInfo(item,date){
        let offer={
            count:1,
            list:[{
                ...this.sales,
                room_offer_arr:{
                    mode:'1',
                    list:[{
                        date:date,
                        offer_info:[
                            ...item,
                        ]
                    }],
                }
            }]
        };
        return offer;
    },
    //关闭抽屉
    handleClose(done) {
        this.$emit('close')
    },
  }
};
</script>

<style lang="scss" scoped>
    .quote-history{
        width: 100%;
        margin: 0 auto;
    }
    .quote-item{
        width: 94%;
        margin: 0 auto;
        margin-top: 20px;
        background-color: #fff;
    }
    .quote-item-date{
        font-size: 12px;
        font-weight: bold;
        width: 92%;
        padding: 3% 4%;
        background-color: #e9eaef;
    }
    .quote-item-series{
        border-left: 1px #eee solid;
        border-right: 1px #eee solid;
    }
    .series{
        width: 90%;
        padding: 0 5%;
        margin: 0 auto;
        font-size: 12px;
        line-height: 40px;
        border-top: 1px #eee solid;
        background-color: #f6f6f8;
        display: flex;
        justify-content: space-between;
        cursor: pointer;
        p{
            display: flex;
            justify-content: center;
            flex-direction: column;
        }  
    }
    .offer_info{
        width: 100%;
        margin: 0 auto;
        display: flex;
    }
    .offer_info div{
        width: 50%;
        font-size: 12px;
        text-align: center;
        line-height: 40px;
        border-bottom: 1px #f5f5f5 solid;
        border-right: 1px #f5f5f5 solid;
    }
    .offer_info div:nth-child(2){
        border-right: none;
    }
    .money{
    color: red;
    font-weight: bold;
    }
    .money span{
        font-size: 10px;
    }
        .team-title{
        text-align: left;
        display: flex;
        justify-content: space-between;
        background-color: #fff;
        width: 94%;
        padding: 0 3%;
        padding-bottom: 10px;
        margin: 0 auto;
    }
    .team-title-tiem{
        color: #999;
    }
    .team-title-name{
        font-weight: bold;
        font-size: 18px;
    }
    .dayDate-top-close{
        background-color: var(--smtc-color-back);
        width: 40px;
        text-align: center;
        height: 40px;
        line-height: 40px;
        border-radius: 50px;
        color: #666;
        font-size: 10px;
        cursor: pointer;
        margin-top: 4px;
    }
    .quote-history-btn{
        width: 94%;
        margin: 0 auto;
        margin-top: 20px;
    }
    .iconfont{
        font-size: 13px;
        margin-right: 10px;
    }
    .drawer-content{
        width: 100%;
        height: 100%;
        background-color: var(--smtc-color-back);
    }
</style>
